// Alerts on this computer (school console, 2026-10-17): new notifications pop up in the console and,
// when allowed, as desktop alerts with a chime. Staff choose here, per computer, which kinds pop up;
// every notification still lands in the bell.
import { useState } from "react";
import { Banner, Button, Card, Switch } from "@vavr/ui";
import { ALERT_CATEGORIES, alertPrefs, api, askDesktop, chime, desktopState, setAlertPrefs, showDesktop, type DesktopState } from "../shared/index.ts";
import { useAction } from "./data.tsx";

export function AlertsCard({ scope = "console" }: { scope?: string }) {
  const [desktop, setDesktop] = useState<DesktopState>(() => (typeof window === "undefined" ? "unsupported" : desktopState()));
  const [p, setP] = useState(() => (typeof window === "undefined" ? { desktop: true, sound: true, quiet: [] as string[] } : { quiet: [] as string[], ...alertPrefs(scope) }));
  const act = useAction();
  const keep = (next: typeof p) => { setP(next); setAlertPrefs(scope, next); };
  const quiet = p.quiet ?? [];
  return (
    <Card title="Alerts on this computer" description="New notifications pop up while the console is open. Desktop alerts also show when it is in another tab. Everything always goes in the bell.">
      <div className="pmu-stack">
        {act.error && <Banner tone="danger" title={act.error} />}
        {desktop === "granted" && <Switch label="Desktop alerts" checked={p.desktop} onCheckedChange={(v) => keep({ ...p, desktop: v })} />}
        {desktop === "default" && <div className="pmu-row"><span>Desktop alerts are off on this computer.</span><Button size="sm" onClick={async () => setDesktop(await askDesktop())}>Turn on desktop alerts</Button></div>}
        {desktop === "denied" && <Banner tone="warning" title="This browser blocks Vavr's notifications. Allow them in the site settings (the icon left of the address), then reload." />}
        <Switch label="Play a sound" checked={p.sound} onCheckedChange={(v) => { keep({ ...p, sound: v }); if (v) chime(); }} />
        <fieldset className="pmu-stack pmu-c-tight">
          <legend className="pmu-field__label">Pop up for</legend>
          {ALERT_CATEGORIES.map(([k, label]) => (
            <Switch key={k} label={label} checked={!quiet.includes(k)} onCheckedChange={(on) => keep({ ...p, quiet: on ? quiet.filter((x) => x !== k) : [...quiet, k] })} />
          ))}
        </fieldset>
        <div className="pmu-row">
          <Button variant="secondary" loading={act.busy} onClick={async () => { await act.run(() => api("POST", "/api/v1/me/notifications/test")); if (p.desktop) showDesktop("Test alert", "Alerts work on this computer."); }}>Send me a test alert</Button>
          <span className="pmu-small pmu-muted">It arrives within 15 seconds.</span>
        </div>
      </div>
    </Card>
  );
}
